module.exports = __webpack_public_path__ + "img/sichuan.bc89c58d.jpg";